import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { Box } from '@vk-hr-tek/ui/Box';
import { FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { FormKnownValue, FormKnownValues } from '@vk-hr-tek/ui/form';
import { Link } from '@vk-hr-tek/ui/Link';
import { Redo } from '@vk-hr-tek/ui/Redo';
import { Callout } from '@vk-hr-tek/ui/Callout';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { useDispatch, useSelector } from '@app/hooks';

import {
  registerAli,
  registerAliInit,
  selectNotification,
  selectPhone,
  selectSnils,
  selectStatus,
  redirectToQr,
  selectAuthInstance,
} from '../../../slice';
import { RegisterAliDto } from '../../../dto';
import { Button } from '../../../segments';

export const RegisterFinish = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);

  const error = useSelector(selectNotification);
  const snils = useSelector(selectSnils);
  const phone = useSelector(selectPhone);
  const status = useSelector(selectStatus);
  const authInstance = useSelector(selectAuthInstance);

  const { button_color: buttonColor } = authInstance;

  const onSubmit = (values: RegisterAliDto) =>
    new Promise((resolve) => {
      dispatch(
        registerAli({
          values,
          actions: { resolve },
        }),
      );
    });

  const resendCode = () => {
    return new Promise((resolve) => {
      dispatch(
        registerAliInit({
          values: { phone: phone || '' },
          actions: { resolve },
        }),
      );
    });
  };

  return (
    <div>
      <Form
        validate={(values) =>
          validator.validate(values, RegisterAliDto, ['code-verify'])
        }
        onSubmit={onSubmit}
        render={({
          handleSubmit,
          submitting,
          pristine,
          hasValidationErrors,
          dirtySinceLastSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FormKnownValues>
              <FormKnownValue label="СНИЛС" value={snils} />
              <FormKnownValue label="Номер телефона" value={phone} />
            </FormKnownValues>
            <Box mt="24">
              <TextInput
                name="code"
                label="Код подтверждения"
                placeholder="Введите код"
                type="number"
                inputMode="numeric"
                autocomplete="one-time-code"
                id="qaAuthLoginFinishCodeInput"
                testId="test-id-verify-code-input"
              />
            </Box>
            <Box mb="12">
              <Callout>
                <Typography color="text.light.primary" variant="body3">
                  Код поступит в MAX или придёт по СМС
                </Typography>
              </Callout>
            </Box>
            <Redo label="Отправить код повторно" action={resendCode} />
            <Box mt={{ xs: '32', md: '48' }}>
              <Button
                color={buttonColor && `#${buttonColor}`}
                disabled={pristine || hasValidationErrors}
                loading={submitting}
                testId="test-id-code-submit-button"
              >
                Подтвердить
              </Button>
            </Box>
            {!dirtySinceLastSubmit && status && status === 'failed' && (
              <FormError error={error} />
            )}
            <Box
              mt={{ xs: '24', md: '16' }}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Link
                onClick={() => dispatch(redirectToQr())}
                size="small"
                variant="tertiary"
              >
                Выход к QR-коду
              </Link>
            </Box>
          </form>
        )}
      />
    </div>
  );
};
